import React from 'react';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/PageHero';
import FilloutEmbed from '../components/FilloutEmbed';
import FadeIn from '../components/FadeIn';

export default function PrivateTour() {
  return (
    <main className="bg-brand-vintage pb-0">
      <SeoMeta 
        title="Book a Private Tour | Padua Weddings" 
        description="Schedule a private tour of Padua Hills Theatre. Walk the grounds, see the spaces, and discover why our Spanish Revival estate is perfect for your wedding." 
      />
      
      <PageHero 
        title="Book a Private Tour" 
        subtitle="Experience the scale, the warmth, and the mountain views of the estate in person."
        image="https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-168.jpg"
      />

      <section className="py-24 px-6 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">
        <FadeIn className="flex flex-col justify-center">
          <span className="text-brand-bronze uppercase tracking-[0.4em] text-[10px] font-bold mb-6 block">
            Consultative Approach
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-brand-charcoal mb-8 font-light">
            Start With Your Date
          </h2>
          <p className="font-sans text-brand-charcoal/80 text-lg leading-relaxed font-light mb-8">
            The best way to understand if Padua is the right fit for your celebration is to walk the grounds. A private tour allows you to feel the mountain breeze, see the architectural details up close, and discuss your exact vision with our team.
          </p>

          <ul className="space-y-6 border-t border-brand-stone/30 pt-8">
            <li className="flex flex-col">
              <span className="font-serif text-xl text-brand-charcoal mb-1">Private Tours in Claremont</span>
              <span className="font-sans text-brand-charcoal/70 font-light text-sm">Walk the grounds and ask questions specific to your date to ensure our estate perfectly aligns with your vision.</span>
            </li>
            <li className="flex flex-col">
              <span className="font-serif text-xl text-brand-charcoal mb-1">Walk the Flow</span>
              <span className="font-sans text-brand-charcoal/70 font-light text-sm">We'll guide you from guest arrival through the ceremony courtyard, sunset terrace, and historic ballroom.</span>
            </li>
            <li className="flex flex-col">
              <span className="font-serif text-xl text-brand-charcoal mb-1">Discuss Your Vision</span>
              <span className="font-sans text-brand-charcoal/70 font-light text-sm">Share your ideas, and we'll explain how our chef-driven catering and layout can bring them to life.</span>
            </li>
            <li className="flex flex-col">
              <span className="font-serif text-xl text-brand-charcoal mb-1">Get Transparent Answers</span>
              <span className="font-sans text-brand-charcoal/70 font-light text-sm">From date availability and event minimums to menu options, we provide clear, consultative answers.</span>
            </li>
          </ul>
        </FadeIn>

        <FadeIn delay={0.2} className="relative z-10 w-full min-h-[500px]">
          <div className="bg-white rounded-sm shadow-2xl p-2 h-full border border-brand-stone/20">
            <FilloutEmbed />
          </div>
        </FadeIn>
      </section>
    </main>
  );
}